import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class Location extends Component {

  MAP_ELEMENT_ID = 'objectLocationMap';

  MAP_MAX_ZOOM = 18;

  map = null;

  markers = {};

  form = null;

  buttons = {};

  inputs = {};

  configure() {
    return super.configure();
  }

  initialize() {

    this.form = $('.is-object-form');

    this.start();
    return super.initialize();
  }

  start() {

    if (this.form.length !== 1) {
      return false;
    }

    this.readInputs();
    this.readButtons();
    this.initMap();
    this.subscribeToEvents();
  }

  subscribeToEvents() {

    this.inputs.address.on('keypress', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        return this.searchByAddress(event);
      }
    });

    this.buttons.searchByAddress.on('click', (event) => {
      return this.searchByAddress(event);
    });
    this.buttons.searchByPositionPoint.on('click', (event) => {
      return this.onPointInputChanged(event);
    });
    this.buttons.searchByViewPoint.on('click', (event) => {
      return this.onPointInputChanged(event);
    });

    ['position', 'view'].forEach((type) => {
      this.inputs[type + 'PointLng'].on('change keyup', (event) => {
        return this.onPointInputChanged(event);
      });
      this.inputs[type + 'PointLat'].on('change keyup', (event) => {
        return this.onPointInputChanged(event);
      });
    });

  }

  readInputs() {

    this.form.find('input').each((index, element) => {
      element = $(element);
      if (element.attr('name') != null) {
        let name = $.snakeToCamelCase(element.attr('name'));
        this.inputs[name] = element;
      }
    });

  }

  readButtons() {

    this.form.find('button').each((index, element) => {
      element = $(element);
      if (element.attr('name') != null) {
        let name = $.snakeToCamelCase(element.attr('name'));
        this.buttons[name] = element;
      }
    });

  }

  setPointInputCoordinates(type, coordinates, isWithChangeEvent) {
    this.inputs[type + 'PointLng'].val((coordinates.lng || 0).toFixed(6));
    this.inputs[type + 'PointLat'].val((coordinates.lat || 0).toFixed(6));

    if (typeof isWithChangeEvent === 'boolean' && isWithChangeEvent === true) {
      this.inputs[type + 'PointLng'].change(); // Only one is enough
    }

  }

  getPointInputCoordinates(type) {
    return [
      Number(this.inputs[type + 'PointLng'].val()) || 0,
      Number(this.inputs[type + 'PointLat'].val()) || 0
    ]
  }

  onPointInputChanged() {
    this.createOrUpdateMarkerOnMap('position');
    this.createOrUpdateMarkerOnMap('view');
    this.map.fitBounds([
      this.getPointInputCoordinates('position'),
      this.getPointInputCoordinates('view')
    ]);
  }

  searchByAddress(event) {

    let button = this.buttons.searchByAddress,
        query = this.inputs.address.val();

    event.preventDefault();

    button.addClass('is-loading');

    this.App.Geo.Location.search(query, (result) => {

      button.removeClass('is-loading');

      if (typeof result.lat == 'number') {
        this.setPointInputCoordinates('position', result);
        this.setPointInputCoordinates('view', {
          lat: result.lat + 0.0002,
          lng: result.lng + 0.0002
        }, true);
      }
    });

    return false;
  }

  initMap() {

    this.map = this.App.Map.Manager.create(this.MAP_ELEMENT_ID, {
      config: {
        maxZoom: this.MAP_MAX_ZOOM,
        center:  this.getPointInputCoordinates('position')
      }
    });

    if (
      this.getPointInputCoordinates('position')[0] !== 0
      && this.getPointInputCoordinates('position')[1] !== 0
    ) {

      this.createOrUpdateMarkerOnMap('position');
      this.createOrUpdateMarkerOnMap('view');

      this.map.setCenter(this.getPointInputCoordinates('position'), this.MAP_MAX_ZOOM);

      this.map.fitBounds([
        this.getPointInputCoordinates('position'),
        this.getPointInputCoordinates('view')
      ]);

    }

  }

  createOrUpdateMarkerOnMap(type) {
    if (typeof this.markers[type] === 'undefined') {

      this.markers[type] = this.map.addMarker(
        this.getPointInputCoordinates(type),
        {
          draggable:  true,
          element:    this.createMarkerIcon(type)
        },
        type,
        {
          type: type
        }
      );

      this.markers[type].on('drag', (event) => {
        return this.onMarkerDrag(event);
      });

    } else {
      this.markers[type].setLngLat(this.getPointInputCoordinates(type));
    }
  }

  createMarkerIcon(type) {

    let icon = (type === 'position' ? 'fa-walking' : 'fa-eye'),
        importantStyle = (type === 'position' && (this.inputs.isImportant && this.inputs.isImportant.is(':checked') ? 'is-important' : ''));

    return $('<span class="map-marker map-marker-numeric map-object-' + type + '-point '+ importantStyle +'">' +
      '<span class="map-marker-label">' +
      '<span class="icon"><i class="far '+ icon +'"></i></span>' +
      '</span>' +
      '</span>').get(0);

  }

  onMarkerDrag(event) {
    this.setPointInputCoordinates(
      event.target.properties.type,
      event.target.getLngLat()
    )
  }

}